// extracted by mini-css-extract-plugin
export var container = "footer-module--container--HXu2X";
export var reference = "footer-module--reference--2abj_";